import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import {
  IconButton,
  InputAdornment,
  Modal,
  TextField,
  Typography,
} from '@material-ui/core';
import { Search } from '@material-ui/icons';
import selectTableHOC from 'react-table/lib/hoc/selectTable';
import ReactTable from 'react-table';
// React-table library requires to import css as well:
import 'react-table/react-table.css'; // eslint-disable-next-line
import ActionButton from '../../../components/ActionButton';
import {
  getCountEserciziCommerciali,
  getEserciziCommercialiFiltered,
} from '../../../utils/api/esercizi_commerciali_api';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(4),
    textAlign: 'center',
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(3),
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '90%',
    maxWidth: '960px',
    maxHeight: '90vh',
  },
});

const SelectTable = selectTableHOC(ReactTable);

class ModalSelezioneEsercizioCommerciale extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colonneEsercizi: [],
      selectedEsercizio: -1,

      loadedPage: 0,
      totalPages: 1,
      loading: false,
      esercizi: [],

      emailFilter: '',
      nameFilter: '',
    };
  }

  componentDidMount() {
    if (this.props.gruppoId != null) {
      this.onFetchData({ page: 0, pageSize: 10 });
    }
  }

  getEserciziColumn = () => {
    return [
      {
        Header: 'Id',
        id: 'IdEsercizio',
        filterable: false,
        accessor: (data) => data.id,
      },
      {
        Header: 'Email',
        id: 'EmailEsercizio',
        accessor: (data) => data.emailGestore,
        minWidth: 210,
        Filter: (cellInfo) => (
          <TextField
            value={this.state.emailFilter}
            onChange={(event) => {
              this.setState({
                emailFilter: event.target.value,
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      this.setState({ loadedPage: 0 }, () =>
                        this.onFetchData({ page: 0, pageSize: 10 }),
                      );
                    }}
                    size="small"
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
      },
      {
        Header: 'Nome',
        id: 'NomeEsercizio',
        minWidth: 210,
        Filter: (cellInfo) => (
          <TextField
            value={this.state.nameFilter}
            onChange={(event) => {
              this.setState({
                nameFilter: event.target.value,
              });
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => {
                      this.setState({ loadedPage: 0 }, () =>
                        this.onFetchData({ page: 0, pageSize: 10 }),
                      );
                    }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        ),
        accessor: (data) => data.nome,
      },
    ];
  };

  toggleSelection = (key, shift, row) => {
    const selectedId = parseInt(key.split('select-')[1], 10);
    this.setState({
      selectedEsercizio: selectedId,
    });
  };

  isSelected = (key) => {
    const id = parseInt(key, 10);
    return this.state.selectedEsercizio === id;
  };

  onFetchData = (state) => {
    this.setState({ loading: true });

    const { gruppoId, consulenteId, filtroGestioneSeparata } = this.props;

    const { emailFilter, nameFilter } = this.state;

    const filtroGestioneApi = filtroGestioneSeparata === true ? true : null;

    getCountEserciziCommerciali(
      gruppoId,
      consulenteId,
      emailFilter,
      nameFilter,
      null,
      null,
      null,
      null,
      null,
      filtroGestioneApi,
    )
      .then((count) => {
        const totalPages = Math.ceil(count / state.pageSize);
        this.setState({ totalPages });

        return getEserciziCommercialiFiltered(
          gruppoId,
          consulenteId,
          null,
          state.page,
          state.pageSize,
          'id',
          emailFilter,
          nameFilter,
          null,
          null,
          null,
          null,
          null,
          filtroGestioneApi,
        );
      })
      .then((response) => {
        const filteredResult =
          filtroGestioneSeparata === true
            ? response.filter(
                (esercizio) => esercizio.gestioneOperativaSeparata,
              )
            : response;

        this.setState({
          esercizi: filteredResult,
          colonneEsercizi: this.getEserciziColumn(),
          loading: false,
          loadedPage: state.page,
        });
      })
      .catch((error) => {
        reportApiError(error);
        this.setState({ loading: false });
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <Modal
        open={this.props.isModalOpen}
        onClose={this.props.closeModal}
        className={classes.modal}
      >
        <div className={classes.modalContainer}>
          <Typography variant="h5">
            Selezionare l'esercizio da associare al nuovo manuale
          </Typography>
          <SelectTable
            selectType="radio"
            toggleSelection={this.toggleSelection}
            isSelected={this.isSelected}
            keyField={'id'}
            filterable={true}
            resizable={true}
            showPageSizeOptions={false}
            showPageJump={false}
            showPaginationBottom={true}
            style={{ width: '85%' }}
            defaultPageSize={10}
            loading={this.state.loading}
            loadingText="Caricamento..."
            page={this.state.loadedPage}
            pages={this.state.totalPages}
            onPageChange={(pageIndex) => {
              this.setState({ loadedPage: pageIndex }, () => {
                this.onFetchData({ page: pageIndex, pageSize: 10 });
              });
            }}
            manual
            onFetchData={(state) => this.onFetchData(state)}
            columns={this.state.colonneEsercizi}
            data={this.state.esercizi}
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun esercizio trovato"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
          />
          <div>
            <ActionButton
              onClick={this.props.closeModal}
              label="Annulla"
              secondaryButton
              disabled={false}
              grayVersion={false}
            />
            <ActionButton
              label="Prosegui"
              disabled={false}
              grayVersion={false}
              onClick={() => {
                if (this.state.selectedEsercizio !== -1) {
                  this.props.openModalitaModal(
                    this.props.consulenteId,
                    this.state.selectedEsercizio,
                    this.props.filtroGestioneSeparata,
                  );
                } else {
                  alert(
                    'Attenzione, occorre selezionare un esercizio commerciale',
                  );
                }
              }}
            />
          </div>
        </div>
      </Modal>
    );
  }
}

ModalSelezioneEsercizioCommerciale.propTypes = {
  classes: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
  consulenteId: PropTypes.string.isRequired,
  filtroGestioneSeparata: PropTypes.oneOf([true, false, null]),
  gruppoId: PropTypes.number.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  openModalitaModal: PropTypes.func.isRequired,
};

export default withStyles(styles)(ModalSelezioneEsercizioCommerciale);
